import { AppState, selectPorjectQuotes } from 'cdx-common';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { QuoteList } from './List';
import { ProjectQuote } from './ProjectQuote';

export const ProjectQuotes = (props: { projectId: ModelId; }) => {

    const params = useParams();
    const quotes = useSelector((state: AppState) => selectPorjectQuotes(state, props.projectId));
    const quoteId = params.quoteId ?? (quotes.length === 1 ? quotes[0].id : null);
    console.log('quoteId', quoteId);

    return quoteId ? <ProjectQuote quoteId={quoteId} /> : <QuoteList projectId={props.projectId} />;
};
